/** Форматирование для кабинета v2: рубли с копейками, числа с пробелами, время по Москве. */

const MSK = 'Europe/Moscow';

/** 4983.67 → «4 983,67 ₽» (всегда 2 знака, неразрывный пробел перед ₽). */
export function rub(value: number | string | null | undefined): string {
  const n = Number(value ?? 0);
  return (
    new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
      n,
    ) + ' ₽'
  );
}

/** Целые рубли: 2500 → «2 500 ₽». */
export function rub0(value: number | string | null | undefined): string {
  return (
    new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(Number(value ?? 0)) +
    '\u00a0₽'
  );
}

/** 4.4 → «4,4 с». */
export function sec(value: number | null | undefined): string {
  return value == null ? '—' : `${value.toFixed(1).replace('.', ',')}\u00a0с`;
}

/** 20006 → «20 006». */
export function num(value: number | null | undefined): string {
  return new Intl.NumberFormat('ru-RU').format(Number(value ?? 0));
}

/** «1 источник», «2 источника», «5 источников». */
export function plural(n: number, one: string, few: string, many: string): string {
  const a = Math.abs(n) % 100;
  const b = a % 10;
  if (a > 10 && a < 20) return many;
  if (b > 1 && b < 5) return few;
  if (b === 1) return one;
  return many;
}

/**
 * Время сообщения для списков: сегодня — «09:41», вчера — «вчера», раньше — «26 окт».
 * Бэкенд отдаёт наивное UTC-время — дописываем «Z».
 */
export function shortWhen(iso: string | null | undefined, now = new Date()): string {
  if (!iso) return '';
  const d = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : iso + 'Z');
  const day = (x: Date) => x.toLocaleDateString('ru-RU', { timeZone: MSK });
  if (day(d) === day(now)) {
    return d.toLocaleTimeString('ru-RU', { timeZone: MSK, hour: '2-digit', minute: '2-digit' });
  }
  const y = new Date(now.getTime() - 86_400_000);
  if (day(d) === day(y)) return 'вчера';
  return d
    .toLocaleDateString('ru-RU', { timeZone: MSK, day: 'numeric', month: 'short' })
    .replace('.', '');
}
